module.exports = __webpack_public_path__ + "d377fa4699f8156ccdb7c4a85e9ca028.png";